import { BlurFilter, Container, Sprite, Spritesheet, Text } from 'pixi.js';

export const createPlayerOverlayContainer = (
  sprites: Spritesheet,
  {
    spriteName,
  }: {
    diameter: number;
    spriteName: string;
  },
): Container => {
  const container = new Container();
  container.name = spriteName;

  const sprite = new Sprite(sprites.textures['hover-icon-background.svg']);
  sprite.name = `${spriteName}-circle`;
  sprite.anchor.set(0.5, 0.5);
  sprite.alpha = 0;
  container.addChild(sprite);
  return container;
};

export const createBadgeSprite = (sprites: Spritesheet): Sprite => {
  const sprite = new Sprite(sprites.textures['hover-icon-background.svg']);
  sprite.anchor.set(0.5, 0.5);
  return sprite;
};

export const createBadgeIcon = (src: string, sprites: Spritesheet) => {
  if (!sprites.textures) {
    return;
  }
  const icon = Sprite.from(sprites.textures[src]);
  icon.name = `badge-icon-${src}`;
  icon.anchor.set(0.5, 0.5);
  return icon;
};

export const addBlur = (element: Sprite | Text, pixiFilters: boolean): void => {
  if (!pixiFilters) {
    return;
  }
  const blur = new BlurFilter();
  blur.blur = 4;
  element.filters = [blur];
};

export const removeBlur = (element: Sprite | Text): void => {
  element.filters = [];
};

export const BADGE_DIAMETER = 25;
